export const BASE_URL = "https://countriesnow.space/api/v0.1/countries/capital"